// extracted by mini-css-extract-plugin
module.exports = {"popover":"Select_popover__e_iQQ","list":"Select_list__GD4gx","button":"Select_button__SM9rP","option":"Select_option__4cALy"};